import { useContext } from "react";
import RetrievalContext from "data-lake/preview/contexts/RetrievalContext";
const useRetrieval = (failWithoutContext = true) => {
  const contextValue = useContext(RetrievalContext);
  if (!contextValue && failWithoutContext) {
    throw new Error("useRetrieval hook needs to be used inside RetrievalContext.Provider");
  }
  return contextValue;
};
export default useRetrieval;
